<template>
  <div class="mcoupon-users">
    <div class="qd-container">
      <van-sticky>
        <div class="qd-head">
          <van-button type="primary" size="small" @click="beginexport">
            <van-icon
              class="iconfont"
              class-prefix="icon"
              name="EXCEL"
            ></van-icon
            >&nbsp;导出数据到Excel
          </van-button>
        </div>
      </van-sticky>
    </div>

    <van-search
      v-model="keyword"
      :placeholder="
        '输入关键词检索（目前结果中共' + data.totalcount + '条数据）'
      "
      @clear="clearSearch"
      @search="submitSearch"
    />

    <div class="users">
      <van-list
        v-model="data.loading"
        :finished="data.finished"
        :finished-text="'没有更多了，共' + data.totalcount + '个记录'"
        @load="onLoad"
      >
        <div class="user" v-for="(item, index) in data.datas" :key="index">
          <img :src="item.avatarurl" alt class="userhead" />
          <div class="userinfo">
            <div class="xl-title">
              {{ item.nickname }}
              <span class="hig">@{{ item.re_nickname }}</span>
            </div>
            <div class="desc">
              {{ item.RegDate_Format }}
              <!-- 这里是坊标签还是放点啥呢，感觉都是通过这个活动加的，放标签没啥用 -->
              <!-- <span class="tag">这里是放标签还是放点啥呢</span> -->
            </div>
          </div>
        </div>
      </van-list>
    </div>

    <van-popup v-model="export_show" :style="{ width: '80%' }">
      <div class="form-body form-info" v-if="export_status == 1">
        <div class="form-row">
          <div class="form-row-title">
            接收数据的邮箱地址
            <span class="small"></span>
          </div>
          <van-field
            v-model="export_email"
            placeholder="请输入您接收数据的邮箱"
            border
          />
        </div>

        <van-button
          square
          type="warning"
          text="确认"
          block
          @click="exportdata"
          style="margin-top:15px"
        />
      </div>

      <div class="form-info form-box" v-if="export_status == 2">
        <van-loading /><br /><br />
        <div class="title">正在处理数据，请稍等...</div>
      </div>

      <div class="form-info form-box" v-if="export_status == 3">
        <van-icon name="success" /><br /><br />
        <div class="title line-bottom">导出成功，请留意您的邮箱</div>
        <div class="small-title">您现在可以关闭本窗口</div>
        <van-button
          square
          type="default"
          text="关闭"
          @click="export_show = false"
          style="margin-top:5px"
        />
      </div>
      <div class="form-info form-box" v-if="export_status == 4">
        <van-icon name="success" /><br /><br />
        <div class="title line-bottom">导出成功，已经开始为您自动下载文件</div>
        <div class="small-title">
          如果您的没有开始自动下载，请<a
            :href="img_host + export_downloadlink"
            target="_blank"
            >点击这里</a
          >手动下载
        </div>
        <van-button
          square
          type="default"
          text="关闭"
          @click="export_show = false"
          style="margin-top:15px"
        />
      </div>
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";

import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
import { Search } from "vant";
import config from "@/config";

Vue.use(Search);
export default {
  name: "app",
  data() {
    return {
      firstloading: false,
      item: null,
      data: {
        page: 1,
        channeltype: 0,
        datas: [],
        loading: false,
        finished: false,
        totalcount: 0,
      },
      couponid: 0,
      keyword: "",

      ismobile: 0,
      export_status: 0,
      export_show: false,
      export_email: "",
      export_loading: false,
      export_downloadlink: "",
      img_host: config.img_host,
    };
  },
  //监听路由的路径，可以通过不同的路径去选择不同的切换效果
  watch: {},
  methods: {
    clearSearch() {
      console.log("cancel-search", this.keyword);
      this.data.datas = [];
      this.data.page = 1;
      this.onLoad();
    },
    submitSearch() {
      this.data.datas = [];
      this.data.page = 1;
      this.onLoad();
    },
    onLoad() {
      var t = this;
      console.log("onLoad", t.data.page);
      console.log("t.couponid", t.couponid);
      t.data.loading = true;
      t.$http
        .get(
          "/Coupon/GetCouponUsers",
          {
            pageindex: t.data.page,
            pagesize: 15,
            couponid: t.couponid || 0,
            KeyWord: t.keyword,
          },
          2
        )
        .then((res) => {
          t.data.loading = false;
          if (res.resultState == 1) {
            t.data.totalcount = res.Data.totalCount;
            t.data.datas = t.data.datas.concat(res.Data.datas);
            t.data.page += 1;
            if (res.Data.datas.length < 15) t.data.finished = true;
          } else {
            t.data.finished = true;
            Toast(res.errorMsg);
          }
          console.log("t.data.finished", t.data.finished);
        })
        .catch((error) => {});
    },

    //开始导出
    beginexport() {
      var t = this;
      t.export_show = true;
      t.export_status = 0;
      if (t.ismobile_()) t.export_status = 1;
      else {
        t.exportdata();
      }
    },
    //开始生成数据
    exportdata() {
      var t = this;
      t.export_loading = true;
      t.export_downloadlink = "";
      t.export_error = "";
      t.export_status = 2;
      var ismobile = t.ismobile_() ? 1 : 0;
      t.$http
        .get(
          "/Coupon/ExportCouponUsersExcel",
          {
            pageindex: t.data.page,
            pagesize: 15,
            couponid: t.couponid || 0,
            KeyWord: t.keyword,
            IsALL: 1,
            ismobile: ismobile, email: t.export_email 
          },
          2
        )
        .then((res) => {
          t.export_loading = false;
          if (res.resultState == 1) {
            localStorage.setItem("form_datas_email", t.export_email);
            t.export_downloadlink = res.Data;
            if (ismobile != 1) {
              t.export_status = 4;
              setTimeout(() => {
                window.top.open(config.img_host + t.export_downloadlink);
              }, 50);
            } else t.export_status = 3;
          } else {
            t.export_error = res.errorMsg;
          }
        })
        .catch((error) => {
          t.export_loading = false;
          t.export_error = "网络异常，请稍后重试";
          // Toast("网络异常，请稍后重试");
        });
    },
  },
  components: {},
  mounted() {
    this.couponid = this.$route.query.id;
    var email = localStorage.getItem("form_datas_email");
    if (email) this.export_email = email;
  },
};
</script>
<style lang="scss">
@import "../../../static/scss/var";
.qd-container {
  padding: 10px 0;
  .qd-head {
    padding: 5px 20px;
    background-color: #f9f9f8;
  }
}
.mcoupon-users {
  .users {
    overflow: hidden;
    padding: 0 10px 0 10px;
    background-color: #fff;
    .user {
      @include flex;
      @include align_items_center;
      padding: 8px 0;
      position: relative;
      .userhead {
        width: 40px;
        height: 40px;
        border-radius: 4px;
      }
      .userinfo {
        margin-left: 8px;
        @include flex_1;
        .xl-title {
          font-size: 14px;
          color: $vm_fontcolor_main;
          .hig {
            color: $vm_bg_minor;
          }
        }
        .desc {
          font-size: 10px;
          color: $vm_fontcolor_minor2;
          .tag {
            background-color: #dedede;
            padding: 2px 6px;
            color: $vm_fontcolor_minor2;
          }
        }
      }
    }
    .user:before {
      content: "";
      position: absolute;
      left: 45px;
      bottom: 0;
      border-bottom: 1px solid #efefef;
      width: 100%;
    }
    .user:last-child::before {
      border-bottom: 0;
    }
  }
}

.form-info {
  padding-top: 20px;
}

.form-box{
  padding:40px 20px;
  text-align: center;
  .small-title{
    color: #636363;
    padding:15px 0;
    a{
      color: $vm_bg_main;
      margin: 0 10px;
    }
    font-size: 14px;
  }
  .title{
    color: #212121;
    font-size: 18px;
  }
  .van-icon{
    font-size: 36px;
    color: green;
  }
  .line-bottom{
    border-bottom: 1px solid #eee; 
    padding-bottom: 15px;
  }
}
</style>
